/**
 * Environment utility constants
 * Evaluated from compile-time env values exposed by Vite.
 */

export const environment: string = import.meta.env.VITE_STAGE;

export const isProduction: boolean = environment === 'prod';

export const isStage: boolean = environment === 'stage';

export const isDevelopment: boolean = ['dev', 'feature'].includes(environment);

export const isLocalhost: boolean = window.location.hostname === 'localhost';

/**
 * Determines the remote translation fetch timeout based on the current environment.
 * Production and stage use a shorter timeout (3s) due to more reliable infrastructure,
 * while dev and feature environments use a longer timeout (5s) to account for variability.
 *
 * @returns {number} Timeout in milliseconds
 */
export const getTranslationRemoteTimeoutMs = (): number => {
  if (isProduction || isStage) {
    return 3000;
  }
  return 5000;
};
